import {
  ForgotPasswordForm,
  ForgotPasswordFormData,
} from '@src/features/user/auth';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { requestResetPassword } from '@src/services/auth.ts';
import { USER_NOT_FOUND } from '@src/constants';

export const ForgotPassword = () => {
  const { t } = useTranslation();

  const handleForgotPassword = async (data: ForgotPasswordFormData) => {
    try {
      await requestResetPassword(data.email);
    } catch (err: any) {
      if (err.response && err.response.data.message.includes(USER_NOT_FOUND)) {
        toast.error(err.response.data.message);

        return;
      }
      toast.error(t('toast.failedToSendEmail'));
    }
  };

  return <ForgotPasswordForm onSubmit={handleForgotPassword} />;
};
